export default {"src":"/_next/static/media/sun_bold.8fa9f9e8.svg","height":24,"width":24};